import { App, Directive, Plugin } from 'vue'
import Can from './Can.vue'
import { can } from './can'

/**
 * v-can="'action.customer.edit'"           → hide if no access
 * v-can.disable="'action.customer.edit'"   → disable if no access
 * v-can.readonly="'action.customer.edit'"  → readonly if no access
 *
 * Do NOT call can() in every component — put this on the element instead.
 */
function applyCanDirective(el: HTMLElement, binding: { value: string; modifiers: Record<string, boolean> }) {
  const permission = binding.value
  if (!permission) return

  const hasAccess = can(permission)
  const { disable, readonly } = binding.modifiers

  // Reset previous application so updates re-apply cleanly
  el.style.removeProperty('display')
  el.removeAttribute('disabled')
  el.removeAttribute('readonly')
  el.classList.remove('opacity-50', 'cursor-not-allowed', 'readonly-permission', 'pointer-events-none')

  if (hasAccess) return

  if (disable) {
    el.setAttribute('disabled', 'disabled')
    el.classList.add('opacity-50', 'cursor-not-allowed', 'pointer-events-none')
    if ('disabled' in el) {
      ;(el as HTMLButtonElement).disabled = true
    }
  } else if (readonly) {
    el.setAttribute('readonly', 'readonly')
    el.classList.add('readonly-permission')
    if ('readOnly' in el) {
      ;(el as HTMLInputElement).readOnly = true
    }
  } else {
    el.style.display = 'none'
  }
}

const canDirective: Directive<HTMLElement, string> = {
  mounted: applyCanDirective,
  updated: applyCanDirective,
}

export const permissionPlugin: Plugin = {
  install(app: App) {
    app.config.globalProperties.$can = can
    app.component('Can', Can)
    app.directive('can', canDirective)
    app.provide('can', can)
  }
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $can: typeof can
  }
}
